// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__26dbX","icon":"Breadcrumbs_icon__2IWX6"};